export default __webpack_public_path__ + "static/media/users.a593e382.svg";